import type { FC } from 'react';

import { CONTENT } from './Empty.const';

import styles from './Empty.module.scss';

interface EmptyProps {
	category: string;
}

export const Empty: FC<EmptyProps> = ({ category }) => {
	const { Icon, text } = CONTENT[category] || CONTENT.other;
	return (
		<div className={styles.empty}>
			<Icon />
			<h3 className={styles.text}>{text}</h3>
		</div>
	);
};
